module.exports = __webpack_public_path__ + "static/media/54.3563ffec.jpg";